import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CaseDetail from "../pages/case/detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/case/:id",
    element: <CaseDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;